/* eslint-disable */
import { useState, useMemo, useRef } from "react";
import ReactQuill from "react-quill";
import "quill/dist/quill.snow.css";
import ImageCompressor from "react-image-file-resizer";
import axios from "axios";

export default function QuillEditor({ data, setData }) {
  const editorRef = useRef();
  const [value, setValue] = useState(data.textEditor);
  const onChange = (content, delta, source, editor) => {
    setData({ ...data, textEditor: editor.getHTML() });
  };

  const uploadImage2 = async (file) => {
    if (file.type === "image/gif") {
      const dataImage = new FormData();
      dataImage.append("upload", file, file.name);

      axios
        .post(
          `https://octopus-app-i4ylg.ondigitalocean.app/upload`,
          dataImage,
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((response) => {
          const editor = editorRef.current.getEditor();
          editor.insertEmbed(editor.getSelection(), "image", response.data.url);
        })
        .catch((error) => console.log(error));
    } else {
      await ImageCompressor.imageFileResizer(
        file,
        Infinity,
        Infinity,
        "webp",
        80,
        0,
        async (uri) => {
          const dataImage = new FormData();
          const blob = await fetch(uri).then((r) => r.blob());
          dataImage.append("upload", blob, file.name);

          axios
            .post(
              `https://octopus-app-i4ylg.ondigitalocean.app/upload`,
              dataImage,
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((response) => {
              const editor = editorRef.current.getEditor();
              editor.insertEmbed(
                editor.getSelection(),
                "image",
                response.data.url
              );
            })
            .catch((error) => console.log(error));
        },
        "base64"
      );
    }
  };

  const imageHandler = async () => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = () => {
      const file = input.files[0];
      if (/^image\//.test(file.type)) {
        uploadImage2(file);
      } else {
        console.warn("You could only upload images.");
      }
    };
  };

  const videoHandler = () => {
    const url = prompt("Please enter the video URL (YouTube, Vimeo, Facebook)");
    let embedUrl = "";
    let videoId = "";
    if (url) {
      if (url.includes("youtu")) {
        videoId = url.split("v=")[1];
        const ampersandPosition = videoId.indexOf("&");
        if (ampersandPosition !== -1) {
          videoId = videoId.substring(0, ampersandPosition);
        }
        embedUrl = `https://www.youtube.com/embed/${videoId}`;
      } else if (url.includes("vimeo")) {
        videoId = url.split(".com/")[1];
        embedUrl = `https://player.vimeo.com/video/${videoId}`;
      } else if (url.includes("facebook.com")) {
        embedUrl = `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
          url
        )}&show_text=0`;
      }

      const editor = editorRef.current.getEditor();
      const range = editor.getSelection();
      const position = range ? range.index : 0;
      const iframe = `<iframe src="${embedUrl}" className="w-full h-80"></iframe>`;
      editor.clipboard.dangerouslyPasteHTML(position, iframe);
    }
  };

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [
            { align: "" },
            { align: "center" },
            { align: "right" },
            { align: "justify" },
          ],
          [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
          ],
          ["link", "image", "video"],
          ["clean"],
          [{ color: [] }, { background: [] }],
        ],
        handlers: {
          image: imageHandler,
          video: videoHandler,
        },
      },
    }),
    []
  );

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
    "color",
    "background",
    "align",
  ];

  return (
    <div className="mb-4">
      <ReactQuill
        theme="snow"
        value={data.textEditor}
        modules={modules}
        ref={editorRef}
        formats={formats}
        onChange={onChange}
        className="w-full bg-white border border-gray-300 rounded-lg  focus:outline-none focus:ring-2  focus:ring-purple-400"
      />
    </div>
  );
}
